/**
 * Check if passed DOM path contains selector
 * Also useful in some specific cases, when we can't use "closest" function (e.g. when we try to get parentElement on SVG)
 */
export default function domPathContains(path, selector) {
    return Boolean(path.find(el => el.matches && el.matches(selector)));
}